// extracted by mini-css-extract-plugin
export default {"value":"ButtonSlider__value--I1C96","wrapper":"ButtonSlider__wrapper--bOab2","handle":"ButtonSlider__handle--Aupda","track":"ButtonSlider__track--CLhWl"};